import type { TPractitionerClient } from "~/database/types";

// AIDEV-NOTE: `pending` is reserved for practitioner-created placeholders;
// `invited` awaits consent; `declined` and `revoked` grant no access.
// `archived` is a practitioner-side HIDE only: data access + RLS are preserved
// (so unarchive is lossless) but the pair is dropped from lists and pickers.
// Keep in sync with the RLS status lists in schema.ts and the session_access
// trigger functions (see docs/specs/client-archive.md).
export const PRACTITIONER_CLIENT_DATA_ACCESS_STATUSES = [
    "active",
    "pending",
    "archived",
] as const satisfies readonly TPractitionerClient["status"][];

// AIDEV-NOTE: Practitioner-visible clients include invited profiles, but their
// client-owned data stays consent-gated; archived/declined/revoked stay excluded.
export const PRACTITIONER_CLIENT_VISIBLE_STATUSES = [
    "active",
    "pending",
    "invited",
] as const satisfies readonly TPractitionerClient["status"][];

export function practitionerClientStatusGrantsDataAccess(
    status: TPractitionerClient["status"],
): boolean {
    return (
        PRACTITIONER_CLIENT_DATA_ACCESS_STATUSES as readonly string[]
    ).includes(status);
}

// AIDEV-NOTE: Archived pairs keep their link + data but must not accept NEW
// session assignments in either direction, and are hidden from client lists.
export function isArchivedPractitionerClientStatus(
    status: TPractitionerClient["status"] | null | undefined,
): boolean {
    return status === "archived";
}
